import axios from 'axios';
import {baseApiUrl} from "../../../mainConfig.js";
const state = {
  accessToken: "",
  activeTabFlags: {
    "digitalWeek2020": {
      label: "Digital Week 2020",
      value: true,
      link: "https://presentation-digital-week.360projectview.com/",
      imageLink: "img/DigitalWeek2020.png"
    },
    "detailedDemoVideo": {
      label: "Detailed Demo Video",
      value: true,
      link: "https://player.vimeo.com/video/429447216",
      imageLink: "img/DetailedDemoVideo.png"
    },
    "presentationRecording": {
      label: "Presentation Recording",
      value: true,
      link: "https://under-construction.geodemosolutions.com/",
      imageLink: "img/PresentationRecording.png"
    },
    "canleyVale": {
      label: "Canley Vale Station",
      value: true,
      link: "https://360-images.geodemosolutions.com/",
      imageLink: "img/CanleyVale.png"
    },
    "jervisBay": {
      label: "Jervis Bay Interchange",
      value: true,
      link: "https://jbr-360pv.geodemosolutions.com/",
      imageLink: "img/JervisBayInterchange.png"
    },
    // "contactUs": {
    //   label: "Contact Us",
    //   value: true,
    //   link: "https://forms.office.com/Pages/ResponsePage.aspx?id=fQWQf6A-_kawfOBWhicIG4joWlHVgNZBoOg2AAFzZyJUNUhMRjNQV0NSU1NGSUJGR09EU0pFMjRJMy4u",
    //   imageLink: "img/ContactUs.png"
    // },
    "otfordTunnel": {
      label: "Otford Tunnel",
      value: true,
      link: "https://otsp-360pv.geodemosolutions.com/",
      imageLink: "img/OtfordTunnel.png"
    },
    "anitaStreet": {
      label: "Anita Street",
      value: true,
      link: "https://anitast-crbr-360pv.geodemosolutions.com/",
      imageLink: "img/AnitaStreet.png"
    },
  }
}
function initialState () {
  return {
    accessToken: "",
    activeTabFlags: {
      "digitalWeek2020": {
        label: "Digital Week 2020",
        value: true,
        link: "https://presentation-digital-week.360projectview.com/",
        imageLink: "img/DigitalWeek2020.png"
      },
      "detailedDemoVideo": {
        label: "Detailed Demo Video",
        value: true,
        link: "https://player.vimeo.com/video/429447216",
        imageLink: "img/DetailedDemoVideo.png"
      },
      "canleyVale": {
        label: "Canley Vale Station",
        value: true,
        link: "https://360-images.geodemosolutions.com/",
        imageLink: "img/CanleyVale.png"
      },
      "jervisBay": {
        label: "Jervis Bay Interchange",
        value: true,
        link: "https://jbr-360pv.geodemosolutions.com/",
        imageLink: "img/JervisBayInterchange.png"
      },
      "presentationRecording": {
        label: "Presentation Recording",
        value: true,
        link: "https://under-construction.geodemosolutions.com/",
        imageLink: "img/PresentationRecording.png"
      },
      // "contactUs": {
      //   label: "Contact Us",
      //   value: true,
      //   link: "https://forms.office.com/Pages/ResponsePage.aspx?id=fQWQf6A-_kawfOBWhicIG4joWlHVgNZBoOg2AAFzZyJUNUhMRjNQV0NSU1NGSUJGR09EU0pFMjRJMy4u",
      //   imageLink: "img/ContactUs.png"
      // },
      "otfordTunnel": {
        label: "Otford Tunnel",
        value: true,
        link: "https://otsp-360pv.geodemosolutions.com/",
        imageLink: "img/OtfordTunnel.png"
      },
      "anitaStreet": {
        label: "Anita Street",
        value: true,
        link: "https://anitast-crbr-360pv.geodemosolutions.com/",
        imageLink: "img/AnitaStreet.png"
      },
    }
  }
}
const mutations = {
  storeAccessToken(state, payload) {
    state.accessToken = payload
  },
  setActiveTabFlag(state, payload) {
    Object.keys(state.activeTabFlags).forEach(item=>{
      state.activeTabFlags[item].value = false
    })
    state.activeTabFlags[payload].value = true
  }
}
const actions = {
  async login({dispatch, commit}, payload) {
    return new Promise(function(resolve, reject) {
      let loginUrl = baseApiUrl+"login"
      let config = {
        responseType: 'json'
      }
      axios.post(loginUrl, payload, config).then(result=>{
        if (typeof(result.data) != "undefined" && typeof(result.data.successfulLogin)!= "undefined" && result.data.successfulLogin == true) {
          resolve(result.data.accessToken)
        }
        else {
          reject("Invalid Login")
        }
      }).catch(error=>{
        reject("Invalid Login")
      })
    });
  }
}
const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
